import { render, staticRenderFns } from "./groupChat.vue?vue&type=template&id=567713ff&scoped=true"
import script from "./groupChat.vue?vue&type=script&lang=js"
export * from "./groupChat.vue?vue&type=script&lang=js"
import style0 from "./groupChat.vue?vue&type=style&index=0&id=567713ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567713ff",
  null
  
)

export default component.exports